import { createContext, useContext } from 'react';

const defaults = { show: true, enabled: true, requiresSubscription: false };
const fallback = { data: null, active: false, ready: true, refresh: async () => {}, feature: () => ({ ...defaults, allowed: true, locked: false }) };
export const SubscriptionContext = createContext(fallback);
export const useSubscription = () => useContext(SubscriptionContext);

export function accessFor(data, game, name, now = Date.now()) {
    const setting = data?.features?.[game]?.[name] || defaults;
    // Show/Enabled are global application switches. Administrators bypass only
    // the paid-subscription requirement, not a feature hidden or disabled by configuration.
    if (data?.isAdmin) return { ...setting, allowed: setting.show && setting.enabled, locked: false };
    const active = !data?.subscription?.cancelled && !!data?.subscription?.startsAt &&
        Date.parse(data.subscription.startsAt) <= now && Date.parse(data.subscription.endsAt) > now;
    const locked = setting.show && setting.enabled && setting.requiresSubscription && !active;
    return { ...setting, locked, allowed: setting.show && setting.enabled && !locked };
}

